import { makeVar } from '@apollo/client'

export const showSearchLayerVar = makeVar<boolean>(false)